module.exports = __webpack_public_path__ + "img/Heavy.310a22da.svg";